module.exports = __webpack_public_path__ + "assets/media/dan-1.4927defa.png";